import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useCardFullColorLayoutStyles = makeStyles({
  textColor: {
    color: tokens.colorBrandBackgroundInverted,
  },
  categoryText: {
    ...shorthands.padding(
      tokens.spacingVerticalS,
      tokens.spacingHorizontalNone,
      tokens.spacingVerticalNone,
      tokens.spacingHorizontalM,
    ),
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
  },
  defaultBackgroundColor: {
    background: tokens.colorBrandForegroundOnLight,
  },
});
